  import React, { useState, useEffect } from "react";
  import 'bootstrap/dist/css/bootstrap.min.css';
  import { Container, Navbar, Nav, Form, FormControl, Button, Badge, Modal , ListGroup} from "react-bootstrap";
  import { ShoppingCart, Heart, Megaphone, User, LogOut, PackageSearch , PlusCircle} from "lucide-react";
  import { useNavigate } from "react-router-dom";
  import nn from "../Images/MatiHaat-logo.webp";
  import n1 from "../Images/demo01-slide-01.jpg";
  import n2 from "../Images/demo01-slide-02.jpg";
  import n3 from "../Images/demo01-slide-03.jpg";
  import n4 from "../Images/demo01-slide-04.png";
  import n5 from "../Images/demo01-slide-05.jpg";
  import n6 from "../Images/demo01-slide-06.jpg";
  import n7 from "../Images/demo01-slide-07.jpg";
  import n8 from "../Images/demo01-slide-08.jpg";
  import "../Styles/Header.css";
  import { Carousel } from 'react-bootstrap';
  import LoginPopup from "./LoginPopup";
  // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  // import { faShieldAlt, faTree, faLeaf, faToolbox, faSeedling, faGlobe, faGem } from "@fortawesome/free-solid-svg-icons";
  import { isMobile } from "react-device-detect";

  export default function TopNav({ cartItems, likedItems, addToCart, removeFromLiked , user, setUser, setCartItems, setLikedItems}) {
    const [showCartModal, setShowCartModal] = useState(false);
    const [showLikedModal, setShowLikedModal] = useState(false);
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const navigate = useNavigate();
    const [searchResults, setSearchResults] = useState([]);
  
  
    const handleCartClick = () => setShowCartModal(true);
    const handleLikedClick = () => setShowLikedModal(true);
  
    const proceedToCartPage = () => {
      navigate('/cart');
    };
  
    const navigatehome = () => {
      navigate("/" );
    };
  
    const handleAddToCartFromLikes = (item) => {
      addToCart(item);
      removeFromLiked(item); 
    };
    const [isLoginOpen, setIsLoginOpen] = useState(false);
  
    useEffect(() => {
      const handleStorageChange = () => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          setUser(JSON.parse(storedUser));
          fetchCartItems();
          // fetchLikedItems();
        } else {
          setUser(null);
        }
      };
    
      // Listen for changes in localStorage across tabs
      window.addEventListener("storage", handleStorageChange);
    
      return () => {
        window.removeEventListener("storage", handleStorageChange);
      };
    }, []);
  
  
  
    function updateSearchResults(results) {
      setSearchResults(results); // Store results in state
    }
    
    // useEffect(() => {
    //   if (user) {
    //     fetchCartItems();
    //     fetchLikedItems();
    //   }
    // }, [user]);
    
    useEffect(() => {
      if (query.length > 1) {
        fetch(`https://backend-matihaat.onrender.com/items?q=${query}`)
          .then((res) => res.json())
          .then((data) => {
            setSuggestions(data);  
            updateSearchResults(data); // ✅ Call updateSearchResults here
          })
          .catch((err) => console.error(err));
      } else {
        setSuggestions([]);
        setSearchResults([]); // Clear results if query is empty
      }
    }, [query]);
    
    
  
    const handleSelect = (item) => {
      navigate(`/product/${item.item_name}`, { state: { product: item } });
      setQuery("");
    };
  
    const fetchCartItems = async () => {
      if (!user) return;
      try {
        const response = await fetch(`https://backend-matihaat.onrender.com/cart/${user.userId}`);
        const data = await response.json();
        setCartItems(data || []);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };
    
    const fetchLikedItems = async () => {
      if (!user) return;
      try {
        const response = await fetch(`https://backend-matihaat.onrender.com/liked/${user.userId}`);
        const data = await response.json();
        // setLikedItems(data || []);
      } catch (error) {
        console.error("Error fetching liked items:", error);
      }
    };  
  
    const handleLogout = () => {
      localStorage.removeItem("user");
      setUser(null);
      navigate("/");
    };
  
  // Function to dynamically generate image path based on product name
  function formatImagePath(productName) {
    // Clean up the product name (remove non-alphanumeric characters and trim spaces)
    const cleanProductName = productName.replace(/[^a-zA-Z0-9 ]/g, "").trim().toLowerCase();
  
    // Split the cleaned product name into words
    const productWords = cleanProductName.split(' ');
  
    // Try matching exact image name
    let imageName = `${cleanProductName}.jpg`;  // Exact match name
    let imagePath = `/images1/${imageName}`;
  
    // If no exact match, try matching at least 2 or 3 words
    if (!imageExists(imagePath)) {
      imageName = productWords.slice(0, 3).join('') + '.jpg';  // Take the first 3 words as part of the name
      imagePath = `/images1/${imageName}`;
    }
  
    // If still no match, try matching the last word of the product name
    if (!imageExists(imagePath)) {
      const lastWord = productWords[productWords.length - 1];  // Last word of product name
      imageName = lastWord + '.jpg';
      imagePath = `/images1/${imageName}`;
    }
  
    // If no match at all, fall back to the default image
    if (!imageExists(imagePath)) {
      imagePath = '';  // Fallback to default image
    }
  
    return imagePath;
  }
  
  // Function to check if the image exists in the public/images1 folder
  function imageExists(path) {
    const img = new Image();
    img.src = path;
    return img.complete;  // Returns true if image exists
  }
    // function formatImagePath(productName) {
    //   console.log(`/images1/${productName.replace(/[^a-zA-Z0-9 ]/g, "").trim()}.jpg`);
    //   return `/images1/${productName.replace(/[^a-zA-Z0-9 ]/g, "").trim()}.jpg`;
    // }  
  
    return (
      <header className="position-relative w-100" style={{
        height: "10vw",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#198754",
      }}>
        <div className="bg-success text-white py-2 text-center overflow-hidden">
          <marquee behavior="scroll" direction="left" scrollamount="6">
            {/* <Megaphone size={20} className="me-2" /> COD Available! Free Returns! Free Shipping above Rs.300/-! Use code "MATI10" for 10% OFF.
          </marquee> */}
          <Megaphone size={20} className="me-2" /> New Website coming soon. Please check back next week
          </marquee>
        </div>
        <Navbar expand="lg" className="py-3 position-relative z-2">
          <Container>
          <Navbar.Brand className="text-white fw-bold">
            <img className="nithin" style={{cursor:"Pointer"}} src={nn} alt="Mati Haat Logo" height="40" onClick={navigatehome} loading="lazy"/>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
              {!isMobile && (
                            <Nav className="me-auto">
                              {[
                                "Nutrition",
                                "Protection",
                                "Soils",
                                "Heritage Seeds",
                                "Equipment",
                                "Gardening",
                                "Knowledge"
                              ].map((item) => {
                                const getPath = (label) => {
                                  switch (label) {
                                    case "Nutrition":
                                      return "/nutrition";
                                    case "Protection":
                                      return "/protection";
                                    case "Soils":
                                      return "/soils";
                                    case "Heritage Seeds":
                                      return "/heritage-seeds";
                                    case "Equipment":
                                      return "/equipment";
                                    case "Gardening":
                                      return "/gardening";
                                    case "Knowledge":
                                      return "/knowledge";
                                    default:
                                      return "/";
                                  }
                                };
              
                                return (
                                  <Nav.Link
                                    key={item}
                                    className="text-white text-nowrap"
                                    onClick={() => navigate(getPath(item))}
                                  >
                                    {item}
                                  </Nav.Link>
                                );
                              })}
                            </Nav>
                          )}
              <Form className="d-flex align-items-center">
                <FormControl
                  type="search"
                  placeholder="Search"
                  className="me-2 rounded-pill"
                  aria-label="Search"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
                <Button variant="outline-light" className="rounded-pill me-2">
                  <i className="bi bi-search"></i>
                </Button>
                
                {suggestions.length > 0 && (
                  <ListGroup
                    className="position-absolute w-100 bg-white shadow rounded"
                    style={{
                      top: "41%", // Ensures it's placed right below search bar
                      left: "unset",
                      zIndex: 10,
                      maxHeight: "415px",
                      width: "321px",
                      overflowY: "auto",
                    }}
                  >
                    {suggestions.map((item) => (
                    <ListGroup.Item
                      key={item.item_id}
                      onClick={() => handleSelect(item)}
                      className="dropdown-item d-flex align-items-center"
                      style={{ cursor: "pointer" }}
                    >
                      {formatImagePath(item.item_name) && (
                        <img
                          src={formatImagePath(item.item_name)}
                          alt={item.item_name}
                          className="me-2"
                          style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "5px" }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/images1/default.jpg";
                          }}
                        />
                      )}
                      {/* <img
                        src={formatImagePath(item.item_name)}
                        alt={item.item_name}
                        className="me-2"
                        style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "5px" }}
                        onError={(e) => { e.target.onerror = null; e.target.src = "/images1/default.jpg"; }}
                      /> */}
                      <div>
                        <span className="fw-bold">{item.item_name}</span> - ₹{item.rate}
                      </div>
                    </ListGroup.Item>
                  ))}
                  </ListGroup>
                )}
                <Button variant="outline-light" className="rounded-pill me-2" onClick={handleLikedClick}>
                  <div className="position-relative">
                    <Heart size={20} />
                    {likedItems && likedItems.length > 0 && (
                    <Badge pill bg="danger" className="position-absolute top-0 start-100 translate-middle">
                      {likedItems.length}
                    </Badge>
                  )}
                  </div>
                </Button>
                <Button variant="outline-light" className="rounded-pill" onClick={handleCartClick}>
                  <div className="position-relative">
                    <ShoppingCart size={20} />
                    {cartItems.length > 0 && <Badge pill bg="danger" className="position-absolute top-0 start-100 translate-middle">{cartItems.length}</Badge>}
                  </div>
                </Button>
              </Form>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        
         {/* Modal for Cart Items */}
         <Modal show={showCartModal} onHide={() => setShowCartModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Cart Items</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {cartItems.length === 0 ? (
              <p>No items in the cart</p>
            ) : (
              cartItems.map((item, index) => (
                <div key={index} className="d-flex align-items-center mb-3">
                  <img src={item.img} alt={item.name} style={{ width: 50, height: 50, objectFit: "cover" }} loading="lazy"/>
                  <div className="ms-3">
                    <h5>{item.name}</h5>
                    <p>{item.price}</p>
                  </div>
                </div>
              ))
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={proceedToCartPage}>Checkout</Button>
          </Modal.Footer>
        </Modal>
  
        {/* Modal for Liked Items */}
        <Modal show={showLikedModal} onHide={() => setShowLikedModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Liked Items</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {likedItems.length === 0 ? (
              <p>No items liked</p>
            ) : (
              likedItems.length>0 && Array.isArray(likedItems) && likedItems.map((item, index) => (
                <div key={index} className="d-flex align-items-center mb-3">
                  <img src={item.img} alt={item.name} style={{ width: 50, height: 50, objectFit: "cover" }} loading="lazy"/>
                  <div className="ms-3">
                    <h5>{item.name}</h5>
                    <p>{item.price}</p>
                    <Button
                      variant="success"
                      className="rounded-pill ms-3"
                      onClick={() => handleAddToCartFromLikes(item)}
                    >
                      <PlusCircle size={20} /> Add to Cart
                    </Button>
                  </div>
                </div>
              ))
            )}
          </Modal.Body>
        </Modal>
        {!user && isLoginOpen && (
          <div className="login-container">
            <LoginPopup
              setUser={setUser}
              isOpen={true}  // Keep it always open when `isLoginOpen` is true
              onClose={() => setIsLoginOpen(false)}
              onLogin={(user) => {
                setUser(user);
                setIsLoginOpen(false);
              }}
              user
            />
          </div>
        )}
      </header>
    );
  }
  